<template>
    <el-dialog
            title="批量导入"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            @opened="onDialogOpened"
            width="825px">
        <div class="luckysheet-wrapper">
            <div id="luckysheet"></div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ formTextConfig.cancel }}</el-button>
            <el-button type="primary" :disabled="code.buttonDisable" @click="addUser">{{ code.label }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {batchAddUsers} from "@/api/user";

export default {
    data() {
        return {
            dialogVisible: false,
            code: {
                buttonDisable: false,
                label: '确定',
            },
            titles: ['用户名*','姓名*','手机号','邮箱','密码*','身份证号','校验结果（留空）'],
            fields: ['username', 'realname', 'phone', 'email', 'password','idCardNo'],
            contextMenuObserver: null,
        }
    },
    computed: {
        addTextConfig() {
            return this.$store.state.global.textConfig.backend.reviewer.button.add
        },
        formTextConfig() {
            return this.addTextConfig.form
        },
    },
    methods: {
        open() {
            this.dialogVisible = true
        },
        onDialogOpened(){
            this.init()
        },
        init() {
            this.$nextTick(() => {
                if (window.luckysheet && document.getElementById('luckysheet')) {
                    // 创建luckySheet
                    window.luckysheet.create({
                        container: 'luckysheet',
                        lang: 'zh', // 设定表格语言
                        title: '用户上传',
                        showtoolbar: false,
                        showinfobar: false,
                        showsheetbar: false,
                        sheetFormulaBar: false,
                        cellRightClickConfig: {
                            // copy: false, // 复制
                            copyAs: false, // 复制为
                            // paste: false, // 粘贴
                            // insertRow: false, // 插入行
                            // insertColumn: false, // 插入列
                            // deleteRow: false, // 删除选中行
                            // deleteColumn: false, // 删除选中列
                            deleteCell: false, // 删除单元格
                            hideRow: false, // 隐藏选中行和显示选中行
                            hideColumn: false, // 隐藏选中列和显示选中列
                            rowHeight: false, // 行高
                            columnWidth: false, // 列宽
                            // clear: false, // 清除内容
                            matrix: false, // 矩阵操作选区
                            sort: false, // 排序选区
                            filter: false, // 筛选选区
                            chart: false, // 图表生成
                            image: false, // 插入图片
                            link: false, // 插入链接
                            data: false, // 数据验证
                            cellFormat: false // 设置单元格格式
                        },
                        data: [
                            {
                                "name": "Sheet1", //  工作表名称
                                "index": 0, //  工作表索引
                                "status": 1, //  激活状态
                                "order": 0, //  工作表的下标
                                "hide": 0, // 是否隐藏
                                "row": 20, //  行数
                                "column": 7, //  列数
                                "defaultRowHeight": 20, //  自定义行高
                                "defaultColWidth": 120, //  自定义列宽
                                "scrollLeft": 0, //  左右滚动条位置
                                "scrollTop": 0, //  上下滚动条位置
                                "isPivotTable": false, // 是否数据透视表
                                "pivotTable": {}, // 数据透视表设置
                                "frozen": {type: 'row'}, //  冻结行列配置
                                "zoomRatio": 1, // 缩放比例
                                "showGridLines": 1, //  是否显示网格线
                                "dataVerification": {}, //  数据验证配置
                            },
                        ]
                    })

                    setTimeout(() =>{
                        for (let i = 0; i < this.titles.length; i++) {
                            luckysheet.setCellValue(0, i, this.titles[i])
                        }
                    },500)

                    // 监控并修改右键菜单样式
                    this.modifyExistingContextMenu();
                }
            })
        },
        modifyExistingContextMenu() {
            const dialog = document.querySelector('.el-dialog__wrapper');
            let dialogZIndex = 2000;

            if (dialog) {
                const computedStyle = window.getComputedStyle(dialog);
                dialogZIndex = parseInt(computedStyle.zIndex) || 2000;
            }

            // 移除旧的style
            if (this.contextMenuStyleId) {
                const oldStyle = document.getElementById(this.contextMenuStyleId);
                if (oldStyle) {
                    document.head.removeChild(oldStyle);
                }
            }

            const styleId = 'luckysheet-context-menu-fix-' + Date.now();
            const style = document.createElement('style');
            style.id = styleId;

            // 只针对显示的右键菜单设置高z-index
            style.innerHTML = `
        /* 所有幸运表格右键菜单基础样式 */
        .luckysheet-context-menu,
        .luckysheet-menu-list,
        .luckysheet-cols-menu,
        .luckysheet-rows-menu {
            /* 默认状态不设置z-index，避免遮挡 */
        }

        /* 只有特定的显示状态才提高层级 */
        .el-dialog__wrapper .luckysheet-context-menu,
        .el-dialog__wrapper .luckysheet-menu-list,
        .el-dialog__wrapper .luckysheet-cols-menu,
        .el-dialog__wrapper .luckysheet-rows-menu {
            z-index: ${dialogZIndex + 10} !important;
        }
    `;

            document.head.appendChild(style);
            this.contextMenuStyleId = styleId;

            // 监听右键菜单显示
            this.setupContextMenuListener(dialogZIndex);
        },
        setupContextMenuListener(dialogZIndex) {
            // 使用事件委托监听点击
            document.addEventListener('contextmenu', (e) => {
                // 检查是否是右键菜单相关元素
                const isContextMenu = e.target.closest('.luckysheet-context-menu, .luckysheet-menu-list, .luckysheet-cols-menu, .luckysheet-rows-menu');

                // 找到所有右键菜单元素
                const menuElements = document.querySelectorAll('.luckysheet-context-menu, .luckysheet-menu-list, .luckysheet-cols-menu, .luckysheet-rows-menu');

                menuElements.forEach(menu => {
                    const style = window.getComputedStyle(menu);
                    if (style.display === 'block') {
                        // 显示的菜单设置高z-index
                        menu.style.zIndex = `${dialogZIndex + 10}`;
                    } else {
                        // 隐藏的菜单移除z-index
                        menu.style.zIndex = '';
                    }
                });
            }, true);

            // 监听右键菜单隐藏
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.removedNodes && mutation.removedNodes.length > 0) {
                        // 检查是否有右键菜单被移除
                        mutation.removedNodes.forEach(node => {
                            if (node.nodeType === 1 &&
                                    (node.className &&
                                            (node.className.includes('luckysheet-context-menu') ||
                                                    node.className.includes('luckysheet-menu-list') ||
                                                    node.className.includes('luckysheet-cols-menu') ||
                                                    node.className.includes('luckysheet-rows-menu')))) {
                                // 清理z-index
                                node.style.zIndex = '';
                            }
                        });
                    }
                });
            });

            observer.observe(document.body, { childList: true, subtree: true });

            // 保存observer以便清理
            this.contextMenuObserver = observer;
        },
        /**
         * 删除所有错误提示信息
         */
        delErrorMessage() {
            let maxRow = luckysheet.getAllSheets()[0].data.length
            let messageY = luckysheet.getAllSheets()[0].column
            for (let i = 1; i < maxRow; i++) {
                luckysheet.setCellValue(i, messageY - 1, null)
            }
        },
        /**
         * 判断对象除指定属性，其它所有属性的值都为null
         *
         * @param obj
         * @returns {boolean}
         */
        allValuesIsNull(obj) {
            // 确保传入的是一个对象
            if (typeof obj !== 'object' || obj === null) {
                return false
            }

            // 使用for...in循环遍历对象的属性
            for (const key in obj) {
                // 跳过原型链上的属性
                if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                    continue
                }

                // 如果发现任何非null的值，返回false
                if (obj[key] !== null) {
                    return false
                }
            }
            // 如果所有非指定属性都是null，返回true
            return true
        },
        replaceStr(str) {
            if (!str) {
                return ''
            }
            return str.replace(/[\r\n]/g, "")
        },
        /**
         * 校验身份证号格式（支持15位和18位）
         * @param idCard 身份证号字符串
         * @returns {boolean} 是否合法
         */
        validateIdCardNo(idCard) {
            if (!idCard) {
                return false
            }
            const idCardStr = String(idCard).trim()
            if (idCardStr.length !== 15 && idCardStr.length !== 18) {
                return false
            }
            // 15位身份证：省区(2) + 出生日期(6) + 顺序码(3) + 校验码(1)
            // 18位身份证：省区(2) + 出生日期(8) + 顺序码(3) + 校验码(1)
            // 格式：15位全数字；18位前17位数字 + 最后一位数字或X
            const is15 = /^[1-9]\d{14}$/.test(idCardStr)
            const is18 = /^[1-9]\d{16}[\dXx]$/.test(idCardStr)
            if (!is15 && !is18) {
                return false
            }
            // 18位身份证需校验出生日期和校验码
            if (is18) {
                const birthYear = parseInt(idCardStr.substring(6, 10), 10)
                const birthMonth = parseInt(idCardStr.substring(10, 12), 10)
                const birthDay = parseInt(idCardStr.substring(12, 14), 10)
                const currentYear = new Date().getFullYear()
                if (birthYear < 1900 || birthYear > currentYear) {
                    return false
                }
                if (birthMonth < 1 || birthMonth > 12) {
                    return false
                }
                if (birthDay < 1 || birthDay > 31) {
                    return false
                }
                // 加权求和校验码
                const weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
                let sum = 0
                for (let i = 0; i < 17; i++) {
                    sum += parseInt(idCardStr.charAt(i), 10) * weight[i]
                }
                const lastChar = idCardStr.charAt(17).toUpperCase()
                if (lastChar !== checkCode[sum % 11]) {
                    return false
                }
            }
            return true
        },
        valid(list) {
            // 第一层：必填 + 格式校验（每个字段独立，互不干扰，均为非空时触发）
            list.forEach(item => {
                if(!item.username) {
                    item.result = '用户名不能为空'
                } else if (!item.realname) {
                    item.result = '姓名不能为空'
                } else if (!item.password) {
                    item.result = '密码不能为空'
                } else if (item.idCardNo && !this.validateIdCardNo(item.idCardNo)) {
                    item.result = '身份证号格式不正确'
                }
            })

            // 统计每个字段的重复次数（仅统计已通过第一层校验的行，避免空值干扰）
            const usernameCount = new Map();
            const phoneCount = new Map();
            const emailCount = new Map();
            const idCardNoCount = new Map();

            list.forEach(item => {
                // 只有通过必填校验的行才参与重复统计
                if (!item.result) {
                    if (item.username) {
                        usernameCount.set(item.username, (usernameCount.get(item.username) || 0) + 1);
                    }
                    if (item.phone) {
                        phoneCount.set(item.phone, (phoneCount.get(item.phone) || 0) + 1);
                    }
                    if (item.email) {
                        emailCount.set(item.email, (emailCount.get(item.email) || 0) + 1);
                    }
                    if (item.idCardNo) {
                        idCardNoCount.set(item.idCardNo, (idCardNoCount.get(item.idCardNo) || 0) + 1);
                    }
                }
            });

            // 第二层：重复性校验（仅在无 result 错误时触发）
            list.forEach(item => {
                if (item.result) {
                    return
                }
                if (usernameCount.get(item.username) > 1) {
                    item.result = '重复的用户名';
                } else if (phoneCount.get(item.phone) > 1) {
                    item.result = '重复的手机号';
                } else if (emailCount.get(item.email) > 1) {
                    item.result = '重复的邮箱';
                } else if (idCardNoCount.get(item.idCardNo) > 1) {
                    item.result = '重复的身份证号';
                }
            });

            return list;
        },
        addUser() {
            // 删除错误信息
            this.delErrorMessage()
            // 失去焦点，单元格处在编辑模式下会获取不到当前输入的数据
            luckysheet.exitEditMode()
            let sheets = luckysheet.getAllSheets()
            if (sheets === null || sheets.length === 0) {
                this.$message.error('请正确填写用户信息后，确认上传！')
                return
            }
            let sheet = sheets[0]
            if (sheet.celldata === null || sheet.celldata.length === 0) {
                // 数据表完全没有数据，并且也没有表头
                this.$message.error('用户数据表错误，请恢复数据表！')
                return
            }
            // 有数据的行数，并不一定准确
            let lastRowIndex = sheet.celldata[sheet.celldata.length - 1].r
            // 没有数据，或数据为第一行
            if (lastRowIndex === null || lastRowIndex === 0) {
                this.$message.error('当前表格中无数据可提交，请检查！')
                return
            }
            // sheet.data 当前sheet中的数据，所有行，包含全null行
            let dataList = []

            // 第一次出现全空值的行
            let emptyLineMinRowNum = null
            // 非全空值的最大行
            let notEmptyLineMaxRowNum = null
            for (let i = 1; i <= lastRowIndex; i++) {
                let list = sheet.data[i]
                let obj = {}
                dataList.push(obj)

                for (let j = 0; j < this.fields.length; j++) {
                    if (list[j] && list[j].v) {
                        obj[this.fields[j]] = list[j].v
                    } else if (list[j] && list[j].ct && list[j].ct.s && list[j].ct.s.length > 0) {
                        obj[this.fields[j]] = this.replaceStr(list[j].ct.s[0].v)
                    } else {
                        obj[this.fields[j]] = null
                    }
                }
                if (this.allValuesIsNull(obj)) {
                    if (emptyLineMinRowNum === null ) {
                        emptyLineMinRowNum = i
                    }
                } else {
                    notEmptyLineMaxRowNum = i
                }
            }

            // 全部都为空值
            if (notEmptyLineMaxRowNum === null) {
                this.$message.error('当前表格中无数据可提交，请检查！')
                return
            }

            // 空行的最小值在有数据行的前面，判断excel前部存在空行
            if (emptyLineMinRowNum !== null && notEmptyLineMaxRowNum > emptyLineMinRowNum) {
                this.$message.error('当前表格中存在空行，请检查！')
                return
            }

            // 空行在有数据行的后面，处理掉尾部的所有空行
            if (emptyLineMinRowNum > notEmptyLineMaxRowNum) {
                dataList = dataList.slice(0, notEmptyLineMaxRowNum)
            }

            let maxRow = luckysheet.getAllSheets()[0].data.length
            let messageY = luckysheet.getAllSheets()[0].column
            this.valid(dataList)
            let hasError = false;
            for (let i = 1; i < maxRow; i++) {
                if (dataList[i - 1] && dataList[i - 1].result) {
                    luckysheet.setCellValue(i, messageY - 1, dataList[i - 1].result)
                    hasError = true
                }
            }

            if (hasError) {
                return
            }

            this.code.buttonDisable = true
            this.code.label = '上传中'

            // 调用上传接口，后台验证用户后更新上传状态
            batchAddUsers(dataList).then(res => {
                if (res.status === 200) {
                    let resultList = res.data

                    for (let i = 1; i < maxRow; i++) {
                        if (resultList[i - 1] && resultList[i - 1].result) {
                            luckysheet.setCellValue(i, messageY - 1, resultList[i - 1].result)
                        }
                    }
                }

                this.code.buttonDisable = false
                this.code.label = '确定'
            }).catch(() => {
                this.code.buttonDisable = false
                this.code.label = '确定'
            })
        }
    },
    // 组件销毁时清理
    beforeDestroy() {
        if (this.contextMenuObserver) {
            this.contextMenuObserver.disconnect();
        }
    }
}
</script>

<style scoped>
    .luckysheet-wrapper {
        height: 450px;
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    #luckysheet {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>
